import React from 'react'
import AirplanemodeActiveIcon from '@mui/icons-material/AirplanemodeActive'
import LandscapeIcon from '@mui/icons-material/Landscape'

export const getConciliationTypes = (translate) => [
  {
    id: 'AIR',
    name: translate ? translate('ra.field.conciliation_air') : '',
  },
  {
    id: 'LAND',
    name: translate ? translate('ra.field.conciliation_land') : '',
  },
]

export const getConciliationTypeInfo = (type, translate) => {
  const normalized = typeof type === 'string' ? type.toUpperCase().trim() : ''
  if (normalized === 'AIR') {
    return {
      name: translate ? translate('ra.field.conciliation_air') : '',
      icon: <AirplanemodeActiveIcon fontSize='small' />,
    }
  }
  if (normalized === 'LAND') {
    return {
      name: translate ? translate('ra.field.conciliation_land') : '',
      icon: <LandscapeIcon fontSize='small' />,
    }
  }
  return {
    name: type || '-',
    icon: null,
  }
}
